import React, { useContext } from 'react';

// For some reason, the tooltip unit test fails unless we reference these directly where
// they are exported and not, in the index file where they are re-exported
// import { CustomIcon } from '@/components/primitive';
// import { Theme, ThemeContext } from '@/controllers';
import CustomIcon from '@/components/primitive/icon';
import { Theme, ThemeContext } from '@/controllers/theme-controller';

const SfxIcon = () => {
  const [theme] = useContext(ThemeContext);
  const iconFileName = theme === Theme.Dark ? 'icon-sfx-dark.svg' : 'icon-sfx.svg';
  return <CustomIcon src={`/static/${iconFileName}`} />;
};

export default SfxIcon;
